<div class="main-notification" [ngClass]="classes()">
  {{ notificationMessage() }}
</div>
